/**
 * Broadcasts commands to geometry/index
 */
import {makeVar} from "@apollo/client";

export const geofenceDrawingCommand = makeVar(null);
//re-fires the same command when clicked repeatedly
export const geofenceDrawingCommandCounter = makeVar(0);
export const geofenceDrawingColor = makeVar(null);